module.exports = __webpack_public_path__ + "img/2_117.4ffbf4f6.png";